var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { attrs: { id: "headerDiv" } }, [
      _c(
        "div",
        { attrs: { id: "headDiv" } },
        [
          _c("v-autocomplete", {
            staticStyle: { "min-width": "20vh", "padding-right": "5%" },
            attrs: {
              multiple: "",
              items: _vm.fleets,
              "item-text": "nombre",
              "item-value": "id",
              "append-icon": "",
              label: "Búsqueda por flotas",
              chips: "",
              "deletable-chips": "",
              "search-input": _vm.search
            },
            on: {
              "update:searchInput": function($event) {
                _vm.search = $event
              },
              "update:search-input": function($event) {
                _vm.search = $event
              },
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                ) {
                  return null
                }
                return _vm.updateTags($event)
              }
            },
            scopedSlots: _vm._u([
              {
                key: "prepend-item",
                fn: function() {
                  return [
                    _c(
                      "v-list-tile",
                      [
                        _c("v-checkbox", {
                          attrs: { label: "Seleccionar todos" },
                          on: {
                            change: function($event) {
                              return _vm.selectAllFleets()
                            }
                          },
                          model: {
                            value: _vm.checkAllFleets,
                            callback: function($$v) {
                              _vm.checkAllFleets = $$v
                            },
                            expression: "checkAllFleets"
                          }
                        })
                      ],
                      1
                    ),
                    _c("v-divider")
                  ]
                },
                proxy: true
              },
              {
                key: "selection",
                fn: function(ref) {
                  var item = ref.item
                  var index = ref.index
                  return [
                    index === 0
                      ? _c("v-chip", [
                          _c("span", [
                            _vm._v(_vm._s(_vm.textoComprimido(item.nombre)))
                          ])
                        ])
                      : _vm._e(),
                    index === 1
                      ? _c("span", { staticClass: "grey--text caption" }, [
                          _vm._v(
                            "(+" +
                              _vm._s(_vm.fleetsSelected.length - 1) +
                              " otros)"
                          )
                        ])
                      : _vm._e()
                  ]
                }
              }
            ]),
            model: {
              value: _vm.fleetsSelected,
              callback: function($$v) {
                _vm.fleetsSelected = $$v
              },
              expression: "fleetsSelected"
            }
          }),
          _c(
            "div",
            [
              _c(
                "v-btn",
                {
                  attrs: { color: "#27488E", fab: "", small: "", dark: "" },
                  on: { click: _vm.filterFleets }
                },
                [_c("v-icon", [_vm._v("search")])],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]),
    _c(
      "div",
      { attrs: { id: "bodyDiv" } },
      [
        _c(
          "v-layout",
          [
            _c(
              "v-flex",
              { attrs: { md6: "", sm12: "" } },
              [
                _c(
                  "v-card",
                  {
                    staticClass: "idCard",
                    on: {
                      mouseover: function($event) {
                        _vm.mousePointTransmission = true
                      },
                      mouseleave: function($event) {
                        _vm.mousePointTransmission = false
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "idcardTitle" }, [
                      _c("p", { staticClass: "titleCards" }, [
                        _vm._v("Estado de Transmisión")
                      ]),
                      _c(
                        "div",
                        { staticClass: "exportButton" },
                        [
                          _c("exportMenu", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.mousePointTransmission,
                                expression: "mousePointTransmission"
                              }
                            ],
                            attrs: { type: "transmission" },
                            on: {
                              point: function($event) {
                                _vm.mousePointTransmission = true
                              },
                              exportData: _vm.exportData
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          height: "310px",
                          width: "100%",
                          display: "flex"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              height: "100%",
                              width: "50%",
                              display: "flex",
                              "align-items": "center",
                              "justify-content": "center"
                            }
                          },
                          [
                            _c("div", [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    "justify-content": "center"
                                  }
                                },
                                [
                                  _c(
                                    "h3",
                                    {
                                      staticStyle: { "padding-right": "10px" }
                                    },
                                    [_vm._v("Total:")]
                                  ),
                                  _c("h3", [_vm._v(_vm._s(_vm.total))])
                                ]
                              ),
                              _c(
                                "div",
                                { staticStyle: { display: "flex" } },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "#8dd0b3" } },
                                    [_vm._v("circle")]
                                  ),
                                  _c(
                                    "h3",
                                    {
                                      staticStyle: {
                                        "padding-right": "13px",
                                        "padding-left": "5px"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                    Vehículos en Línea\n                  "
                                      )
                                    ]
                                  ),
                                  _c("h3", [
                                    _vm._v(_vm._s(_vm.inLinePercent) + "%")
                                  ])
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticStyle: { display: "flex" } },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "#f44924" } },
                                    [_vm._v("circle")]
                                  ),
                                  _c(
                                    "h3",
                                    {
                                      staticStyle: {
                                        "padding-right": "13px",
                                        "padding-left": "5px"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                    Vehículos Fuera de Línea\n                  "
                                      )
                                    ]
                                  ),
                                  _c("h3", [
                                    _vm._v(_vm._s(_vm.offLinePercent) + "%")
                                  ])
                                ],
                                1
                              )
                            ])
                          ]
                        ),
                        _c(
                          "div",
                          { staticStyle: { height: "100%", width: "50%" } },
                          [
                            _c("doughnutComp", {
                              ref: "doughnutCompRef",
                              attrs: { height: 280 }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ]
                )
              ],
              1
            ),
            _c(
              "v-flex",
              { attrs: { md6: "", sm12: "" } },
              [
                _c(
                  "v-card",
                  {
                    staticClass: "idCard",
                    on: {
                      mouseover: function($event) {
                        _vm.mousePointTransmissionDetail = true
                      },
                      mouseleave: function($event) {
                        _vm.mousePointTransmissionDetail = false
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "idcardTitle" }, [
                      _c("p", { staticClass: "titleCards" }, [
                        _vm._v("Estado de Transmisión Detalle")
                      ]),
                      _c(
                        "div",
                        { staticClass: "exportButton" },
                        [
                          _c("exportMenu", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.mousePointTransmissionDetail,
                                expression: "mousePointTransmissionDetail"
                              }
                            ],
                            attrs: { type: "transmissionDetail" },
                            on: {
                              point: function($event) {
                                _vm.mousePointTransmissionDetail = true
                              },
                              exportData: _vm.exportData
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          height: "310px",
                          width: "100%",
                          display: "flex"
                        }
                      },
                      [
                        _c("ag-grid-vue", {
                          staticClass: "ag-theme-material",
                          staticStyle: { width: "100%", height: "100%" },
                          attrs: {
                            columnDefs: _vm.columnDefsTransmission,
                            rowData: _vm.rowDataTransmission,
                            gridOptions: _vm.gridOptionTransmission
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }